import { motion } from "framer-motion";
import { PanelsTopLeft, Zap, Construction, Box, Layers, CloudLightning, Cable } from "lucide-react";
import { useLanguage } from "../i18n/translations";

const ICONS = [PanelsTopLeft, Zap, Construction, Box, Layers, CloudLightning, Cable];

export const Equipment = () => {
  const { t } = useLanguage();

  return (
    <section id="equipment" className="border-t border-white/10 bg-navy-900/40 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.65 }}
          className="mb-14 max-w-2xl"
        >
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.3em] text-wind">{t.equip.eyebrow}</p>
          <h2 className="font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl lg:text-4xl">{t.equip.title}</h2>
          <p className="mt-4 text-slate-400">{t.equip.desc}</p>
        </motion.div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="equipment-grid">
          {t.equip.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={item}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
                className={`group rounded-2xl border border-white/10 bg-navy-800/60 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-wind/50 hover:shadow-[0_16px_48px_rgba(56,189,248,0.12)] ${i === 0 ? "sm:col-span-2" : ""}`}
                data-testid={`equipment-item-${i + 1}`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-wind/10 transition-colors duration-300 group-hover:bg-wind/20">
                    <Icon size={21} className="text-wind" />
                  </div>
                  <span className="font-mono text-xs font-bold text-slate-600">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <h3 className="mt-5 font-display text-base font-bold text-white">{item}</h3>
              </motion.div>
            );
          })}

          <motion.a
            href="#contact"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex items-center justify-center rounded-2xl border border-solar/40 bg-solar/10 p-6 text-center font-display text-base font-bold text-solar-highlight transition-colors duration-300 hover:bg-solar hover:text-amber-950"
            data-testid="equipment-quote-cta"
          >
            {t.nav.quote} →
          </motion.a>
        </div>
      </div>
    </section>
  );
};
